import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="category-tree"
export default class extends Controller {
  toggle(event) {
    const checkbox = event.target
    const node = checkbox.closest(".category-node")
    const toggleBtn = node.querySelector(":scope > .d-flex .category-toggle-btn")
    if (!toggleBtn) return // leaf node — no children

    const collapseEl = document.querySelector(toggleBtn.getAttribute("data-bs-target"))
    if (!collapseEl) return

    // Check/uncheck all descendant checkboxes
    collapseEl.querySelectorAll("input[type='checkbox']").forEach(cb => {
      cb.checked = checkbox.checked
    })

    // Auto-expand when checking a parent
    if (checkbox.checked && toggleBtn.getAttribute("aria-expanded") === "false") {
      toggleBtn.click()
    }
  }
}
